import { useRouter } from "next/router";

import AccountSettingsPage from "@/account/AccountSettingsPage";
import withAccountSettingsPrivileges from "@/account/withAccountSettingsPrivileges";
import NewselaGlobalLayout from "@/base";
import RootProviders from "@/base/RootProviders";

const SettingsPageRoute = () => {
  const {
    query: { hide_global_menu: hideHeader },
  } = useRouter();

  return (
    <NewselaGlobalLayout
      mainContents={<AccountSettingsPage />}
      hideHeader={hideHeader}
    />
  );
};

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}

export default withAccountSettingsPrivileges(SettingsPageRoute);
